<template>
  <v-flex>
    <v-btn :disabled="types_clients === 3 || types_clients === 4" @click="openDialog" class="ml-2"
      :color="buston_style ? 'primary' : 'transparent'" :outlined="buston_style">
      <v-icon size="25px">search</v-icon>
      Buscar
    </v-btn>
    <v-dialog v-if="dialogVisible" width="80vw" height="85vh" v-model="dialogSearch"
      transition="dialog-bottom-transition">
      <v-card class="modern-search-card rounded-xl overflow-hidden shadow-xl" height="85vh">
        <v-toolbar flat color="primary" dark class="px-4">
          <v-icon large class="mr-3">person_search</v-icon>
          <div>
            <div class="text-h5 font-weight-black">{{ formTitle }}</div>
            <div class="text-caption opacity-80 mt-n1">Búsqueda rápida de entidades comerciales</div>
          </div>
          <v-spacer></v-spacer>
          <v-btn @click="closeDialog" icon class="bg-white-10">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text class="pa-6">
          <div class="search-container mb-6">
            <v-text-field v-model="search" prepend-inner-icon="search" label="Escriba el nombre o identificación..."
              outlined rounded dense hide-details class="search-bar elevation-1 pt-2" background-color="grey lighten-5"
              autofocus clearable placeholder="Ej: Ochoa, 101..."></v-text-field>
          </div>

          <v-data-table :headers="headers" :items="clients" :search="search" height="55vh" fixed-header
            class="entities-table elevation-0 rounded-lg border" :loading="loadingResults"
            loading-text="Buscando resultados...">

            <!-- Identification Column -->
            <template v-slot:[`item.document_id`]="{ item }">
              <v-chip label small color="blue-grey lighten-5" class="font-weight-bold px-3">
                <span class="primary--text mr-1">{{ item.document_id_type_name || 'ID' }}:</span>
                <span class="grey--text text--darken-3">{{ item.document_id }}</span>
              </v-chip>
            </template>

            <!-- Name/Avatar Column -->
            <template v-slot:[`item.name`]="{ item }">
              <div class="d-flex align-center py-2">
                <v-avatar size="36" color="primary lighten-4" class="mr-3 elevation-1">
                  <span class="primary--text font-weight-bold">{{ item.name.charAt(0) }}</span>
                </v-avatar>
                <div>
                  <div class="text-subtitle-2 font-weight-black grey--text text--darken-3 line-height-1">{{ item.name }}
                  </div>
                  <div class="text-caption grey--text d-flex align-center mt-1"
                    v-if="item.entity_contact_json && item.entity_contact_json.length">
                    <v-icon x-small class="mr-1">mdi-map-marker</v-icon>
                    <span class="text-truncate" style="max-width: 250px;">
                      {{ item.entity_contact_json.find(c => c.id_type === 10)?.description || 'Sin dirección' }}
                    </span>
                  </div>
                </div>
              </div>
            </template>

            <!-- Contact/Phone Column -->
            <template v-slot:[`item.phone_number`]="{ item }">
              <div class="d-flex flex-column" v-if="item.entity_contact_json && item.entity_contact_json.length">
                <div class="d-flex align-center mb-1"
                  v-for="(contact, i) in item.entity_contact_json.filter(c => c.id_type === 3).slice(0, 1)" :key="i">
                  <v-icon x-small color="success" class="mr-2">mdi-phone</v-icon>
                  <span class="text-body-2 grey--text text--darken-2">{{ contact.description }}</span>
                </div>
                <div v-if="!item.entity_contact_json.some(c => c.id_type === 3)" class="text-caption grey--text lighten-2 italic">
                  No registrado
                </div>
              </div>
              <span v-else-if="item.phone_number" class="text-body-2">{{ item.phone_number }}</span>
              <span v-else class="text-caption grey--text lighten-2">N/A</span>
            </template>

            <!-- Email Column -->
            <template v-slot:[`item.email`]="{ item }">
              <div class="d-flex align-center" v-if="item.email">
                <v-icon x-small color="blue" class="mr-2">mdi-email-outline</v-icon>
                <span class="text-body-2 grey--text text--darken-2">{{ item.email }}</span>
              </div>
              <span v-else class="text-caption grey--text lighten-2 italic">Sin correo</span>
            </template>

            <!-- Actions Column -->
            <template v-slot:[`item.actions`]="{ item }">
              <v-btn color="primary" rounded small depressed class="px-4 font-weight-bold" @click="selectItem(item)">
                <v-icon left size="16">mdi-check-circle</v-icon>
                Seleccionar
              </v-btn>
            </template>

            <template v-slot:no-data>
              <div class="text-center pa-10">
                <v-icon size="64" color="grey lighten-3">mdi-magnify-close</v-icon>
                <div v-if="search && search.length >= 2" class="text-h6 grey--text text--lighten-1 mt-4">
                  No se encontraron resultados para "{{ search }}"
                </div>
                <div v-else class="text-h6 grey--text text--lighten-1 mt-4">
                  Empiece a escribir para buscar...
                </div>
              </div>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-flex>
</template>

<script>
export default {
  data: () => ({
    clients: [],
    search: "",
    dialogSearch: false,
    dialogVisible: false,
    loadingResults: false,
    headers: [
      {
        text: "Nombre / Razón Social",
        align: "start",
        sortable: true,
        value: "name",
      },
      { text: "Identificación", value: "document_id", sortable: true },
      { text: "Contacto / Teléfono", value: "phone_number", sortable: false },
      { text: "Correo Electrónico", value: "email", sortable: true },
      { text: "Acciones", value: "actions", sortable: false, align: 'end' },
    ],
    editedIndex: -1,
    editedItem: [],
  }),
  props: {
    types_clients: {
      type: Number,
    },
    location_id: {
      type: Number,
      default: null,
    },
    buston_style: {
      type: Boolean,
      default: false,
    },
    force_open: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    formTitle() {
      return this.types_clients === 1 ? "Suplidores" : "Clientes";
    },
  },
  watch: {
    search(val) {
      if (val.length >= 2) {
        this.searchClient(val);
      } else {
        this.clients = [];
      }
    },
    force_open(val) {
      if (val) {
        this.openDialog();
      } else {
        this.closeDialog();
      }
    }
  },
  methods: {
    // async getData() {
    //   let resultEntity = await this.api_Get("accounting/entity_all");
    //   this.entitys = await resultEntity.json();
    // },
    async searchClient(val) {
      if (!val || val.length < 2) return;
      this.loadingResults = true;
      let typ = this.types_clients == 2 ? "AND IS_CUSTOMER=true" : "AND IS_SUPPLIER=true";
      try {
        const responseRequest = await this.api_Post(
          this.types_clients == 2 ? "accounting/search_client_with_discount" : "accounting/search_entity",
          { name: val, type: typ, location_id: this.location_id, all: false }
        );
        if (responseRequest.status == 200) {
          let data = await responseRequest.json();
          this.clients = data;
        } else {
          this.$toast.error("Error al buscar resultados");
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loadingResults = false;
      }
    },
    openDialog() {
      this.$emit("open-dialog", true);
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.search = "";
        this.clients = [];
        this.dialogSearch = true;
      });
    },
    closeDialog() {
      this.dialogSearch = false;
      this.$nextTick(() => {
        this.dialogVisible = false;
      });
      this.$emit("close-dialog", true);
    },
    selectItem(item) {
      this.$emit("selected-item", item);
      this.dialogSearch = false;
    },
  },
};
</script>

<style scoped>
.modern-search-card {
  background-color: white !important;
}

.bg-white-10 {
  background-color: rgba(255, 255, 255, 0.1) !important;
}

.opacity-80 {
  opacity: 0.8 !important;
}

.line-height-1 {
  line-height: 1.2 !important;
}

.search-bar {
  max-width: 600px;
  margin: 0 auto;
}

.entities-table ::v-deep th {
  background-color: #f8f9fa !important;
  text-transform: uppercase;
  font-size: 0.75rem !important;
  font-weight: 700 !important;
  color: #5e6e82 !important;
  letter-spacing: 0.05em;
}

.entities-table ::v-deep tr:hover {
  background-color: #f1f5f9 !important;
}

.shadow-xl {
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04) !important;
}

.border {
  border: 1px solid #e2e8f0 !important;
}
</style>
